export default [
  { title: "adminSections.dashboard", pathName: "Dashboard" },
  { title: "adminSections.menus", pathName: "Menus" },
  { title: "adminSections.orders", pathName: "Orders" },
  { title: "adminSections.order_history", pathName: "OrdersHistory" },
  { title: "adminSections.store_details", pathName: "StoreDetails" },
  { title: "adminSections.marketing", pathName: "Marketing" },
  { title: "adminSections.refunds", pathName: "Refunds" },
  { title: "adminSections.customers", pathName: "Customers" },
  { title: "adminSections.qrCodes", pathName: "qrcodes" },
];
